import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton,EmptyState,BasicInput,BaasicFormControls } from 'core/components';
import { Content } from 'core/layouts';
import EmptyIcon from 'themes/assets/img/building-modern.svg';

function BulkEmrModalTemplate({ bulkEmrModalStore, t, componentProps}) {
    const {
        items,
        form,
        modalData
    } = bulkEmrModalStore;

    let facilities = items != null ? items.map(facility => {
        return (<tr className={modalData.corporateId !== facility.corporateId ? "warning":""} key={facility.id}>
            <td>
                {facility.name}
            </td>
            <td>
                {facility.address}
            </td>
            <td>
                {facility.corporate}
            </td>
            <td>
                {facility.masterPatientId}
            </td>
        </tr>)
    }) : null;

    return (
        <Content  emptyRenderer={renderEmpty()} >
            <div className="modal__header">
                <h3 className="form__title">Bulk Update EMR</h3>
            </div>
            <div className="modal__body">
                <div className="row">
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('emr')} />
                    </div>
                    {/* <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('emrAccountName')} />
                    </div> */}
                </div>
                <div className="row">
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('emrUserName')} />
                    </div>
                    <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                        <BasicInput field={form.$('emrPassword')} />
                    </div>
                </div>
                <table className="table--preview u-mar--bottom--med">
                    <thead>
                        <tr>
                            <th className="type--left">Name</th>
                            <th className="type--left">Address</th>
                            <th className="type--left">Corporate</th>
                            <th className="type--left">Account Number</th>
                        </tr>
                    </thead>
                    <tbody>{facilities}</tbody>
                </table>
            </div>
            <div className="modal__footer">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Update"  className='btn btn--med btn--primary' />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => componentProps.modalParams.close()}
                />
            </div>
        </Content>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='FACILITY.LIST.EMPTY_STATE.TITLE' description='FACILITY.LIST.EMPTY_STATE.DESCRIPTION' />
}

BulkEmrModalTemplate.propTypes = {
    bulkEmrModalStore: PropTypes.object,
    componentProps: PropTypes.object,
    t:PropTypes.func,
};

export default defaultTemplate(BulkEmrModalTemplate);